/* track special product-item interactions */
$(function(){

    /* Interactions with listing of singles, card zoom icon */
    $(document).on('touchend click','.catalogItem .searchIcon',function(event){
        event.preventDefault();
        let $itemWrapper = $(event.target).parents('.productItemWrapper');
        if($itemWrapper.hasClass('zoomItem')) {
            $itemWrapper.removeClass('zoomItem');
            $itemWrapper.find('.cardLink').removeClass('zoomed');
        } else {
            $itemWrapper.addClass('zoomItem');
            $itemWrapper.find('.cardLink').addClass('zoomed');
        }
    });

});
